import { useContext } from 'react';

import { InputContext } from 'src/contexts/input.context';
import { RadioList } from '../RadioList';
import { t } from 'src/tools/text.tools';
import { ID } from 'src/models';

const TXT = t(['yesNo']);

const ITEMS = [
  { id: 1, label: TXT('true') },
  { id: 0, label: TXT('false') },
];

export function BooleanRadioList() {
  const { value, onChange, ...context } = useContext(InputContext);

  function handleOnChange(value: ID) {
    onChange(Boolean(value), true);
  }

  return (
    <InputContext.Provider value={{ ...context, value: Number(!!value), items: ITEMS, onChange: handleOnChange }}>
      <RadioList />
    </InputContext.Provider>
  );
}
